import { SUBSCRIBE_TO_TOPIC_URL } from "../constants/endpoints";
import axiosClient from "./axios";
import * as Sentry from "@sentry/react";

interface TopicSubscriptionPayload {
  token: string;
}

/**
 * Subscribes an FCM registration token to a Firebase Cloud Messaging topic.
 *
 * This function calls the backend endpoint at http://localhost:3000/api/subscribeToTopic
 * which uses Firebase Admin SDK to subscribe the token to the topic.
 *
 * @param topic - The Firebase Cloud Messaging topic name (e.g., "test_shopid")
 * @param token - The FCM registration token from the client
 * @returns Promise resolving when subscription is complete
 */
export const subscribeUserToTopic = async (token: string) => {
  if (!token) {
    throw new Error("Token is required");
  }

  const payload: TopicSubscriptionPayload = {
    token,
  };

  // Use the backend endpoint via axios client
  const endpoint = SUBSCRIBE_TO_TOPIC_URL;

  try {
    const response = await axiosClient.post(endpoint, payload, {
      timeout: 10000, // 10 second timeout
    });

    return response.data;
  } catch (error: any) {
    Sentry.captureException(error);
    throw error;
  }
};
